class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    // Holds how long we remain on each slide for
    this.slideDuration = this.getAttribute('data-slide-duration')
      ? this.getAttribute('data-slide-duration')
      : 10000;
    // Holds our transition duration which will dynamically append CSS
    this.transitionDuration = this.getAttribute('data-transition-duration')
      ? this.getAttribute('data-transition-duration')
      : 500;
    // Holds our current slide index
    this.currentSlide = 0;
    // Holds our previous slide index
    this.previousSlide = null;
    // Holds all our slides
    this.slides = this.querySelectorAll('.announcement-bar');
    // Holds how many announcement slides we have in total
    this.totalSlides = this.slides.length ? this.slides.length : 0;
    // Holds our interval for the slides
    this.interval = null;

    // No point intializing our rotation if we have one or less slides
    if (this.totalSlides <= 1) return;

    this.createInterval();
  }

  createInterval() {
    this.interval = setInterval(this.nextSlide.bind(this), this.slideDuration);
  }

  nextSlide() {
    this.previousSlide = this.currentSlide;
    // Reset our slide index when we reach the end
    if (this.currentSlide === this.totalSlides - 1) {
      this.currentSlide = 0;
    }
    // Otherwise increment
    else {
      this.currentSlide += 1;
    }

    // Animate out our current slide
    this.slides[this.previousSlide].classList.add('announcement-bar--animate-out');

    const announcementBar = this;

    setTimeout(function () {
      // Hide our current slide and reset classes
      announcementBar.slides[announcementBar.previousSlide].classList.add(
        'announcement-bar--hidden'
      );
      announcementBar.slides[announcementBar.previousSlide].classList.remove(
        'announcement-bar--animate-out'
      );
      // Show our next slide
      announcementBar.slides[announcementBar.currentSlide].classList.remove(
        'announcement-bar--hidden'
      );
      announcementBar.slides[announcementBar.currentSlide].classList.add(
        'announcement-bar--animate-in'
      );

      // Reset the classes on our slides after the animation duration
      setTimeout(function () {
        announcementBar.slides[announcementBar.previousSlide].classList.remove(
          'announcement-bar--visible'
        );
        announcementBar.slides[announcementBar.currentSlide].classList.add(
          'announcement-bar--visible'
        );
        announcementBar.slides[announcementBar.currentSlide].classList.remove(
          'announcement-bar--animate-in'
        );
      }, announcementBar.transitionDuration);
    }, announcementBar.transitionDuration);
  }
}

customElements.define('announcement-bar', AnnouncementBar);
